<template>
<div>
    <owner-form :getOwnerList="getOwnerList" ref="ownerFormModal"></owner-form>
    <agent-transactions-report-trademark-list ref="agentTransactionsReportTrademarkList"></agent-transactions-report-trademark-list>
    <agent-transactions-report-national-trademark-list ref="agentTransactionsReportNationalTrademarkList"></agent-transactions-report-national-trademark-list>
    <agent-transactions-report-trademark-provisional-list ref="agentTransactionsReportTrademarkProvisionalList"></agent-transactions-report-trademark-provisional-list>
    <agent-transactions-report-trademark-objection-to-us-list ref="agentTransactionsReportTrademarkObjectionToUsList"></agent-transactions-report-trademark-objection-to-us-list>
    <agent-transactions-report-trademark-opposition-list ref="agentTransactionsReportTrademarkOppositionList"></agent-transactions-report-trademark-opposition-list>
    <agent-transactions-report-patent-list ref="agentTransactionsReportPatentList"></agent-transactions-report-patent-list>
    <agent-transactions-report-design-list ref="agentTransactionsReportDesignList"></agent-transactions-report-design-list>
    <agent-transactions-report-design-opposition-list ref="agentTransactionsReportDesignOppositionList"></agent-transactions-report-design-opposition-list>
    <agent-transactions-report-domain-list ref="agentTransactionsReportDomainList"></agent-transactions-report-domain-list>
    <agent-transactions-report-law-matter-list ref="agentTransactionsReportLawMatterList"></agent-transactions-report-law-matter-list>
    <context-menu ref="copyMenu"></context-menu>

    <b-row class="align-items-center">
        <b-col class="d-flex align-items-center col-lg-8">
            <div class="mr-1">
                <label for="client-name-input">{{ $t('others.search_name') }}</label>
                <b-form-input id="client-name-input" size="sm" v-model="name" v-on:keyup.enter="getOwnerList()" :placeholder="$t('others.search_name')" type="text" class="d-inline-block mb-2" />
            </div>
            <div class="mr-1">
                <label for="client-country-input">{{ $t('client.country') }}</label>
                <b-form-select id="client-country-input" v-model="countrySelect" size="sm" value-field="id" text-field="name" :options="countryOption" class="mb-2" />
            </div>
            <div class="mr-1">
                <label for="client-sector-input">{{ $t('client.sector') }}</label>
                <v-select id="client-sector-input" v-model="sectorSelectList" :options="sectorOption" :multiple="true" label="nameTR" :reduce="sector => sector.id" class="mb-2" style="min-width: 200px;"></v-select>
            </div>
        </b-col>
        <b-col class="d-flex justify-content-end col-lg-4">
            <b-button style="float:right;" class="mr-05" size="sm" variant="outline-primary" @click="getOwnerList()" v-on:keyup.enter="getOwnerList()">{{ $t('client.list') }}</b-button>
            <b-button style="float:right;" class="mr-05" size="sm" variant="outline-primary" @click="getInfo(0)">{{ $t('client.add') }}</b-button>
            <b-button style="float:right;" size="sm" variant="outline-primary" @click="exportExcel()">{{ $t('excel.excel') }}</b-button>
        </b-col>
    </b-row>
    <!-- table -->
    <vue-good-table id="clientTable" ref="clientTable" :columns="columnsComputed" :rows="rows" :sort-options="{enabled: false}" :search-options="{ enabled: true, externalQuery: searchTerm}" styleClass="vgt-table condensed tableSize" :select-options="{enabled: false, selectOnCheckboxOnly: true, selectionInfoClass: 'custom-class', selectionText: 'rows selected', 
        clearSelectionText: 'clear', disableSelectInfo: true, selectAllByGroup: true}" :pagination-options="{ enabled: true, perPage: pageLength}" theme="my-theme">
        <div slot="emptystate">
            {{ $t('dataTable.data_not_found') }}
        </div>
        <!-- Row: Table Row -->
        <template slot="table-column" slot-scope="props">
            <span v-if="props.column.field === 'name'" class="text-nowrap">
                {{ $t('client.owner_name') }}
            </span>
            <span v-else-if="props.column.field === 'clientAccountingList'">
                <b-row>
                    <b-col>
                        <span>
                            {{ $t('client.trademark_active') }}
                        </span>
                    </b-col>
                    <b-col>
                        <span>
                            {{ $t('client.national_trademark') }}
                        </span>
                    </b-col>
                    <b-col>
                        <span>
                            {{ $t('client.appeal_decision') }}
                        </span>
                    </b-col>
                    <b-col>
                        <span>
                            {{ $t('client.incoming_decision') }}
                        </span>
                    </b-col>
                    <b-col>
                        <span>
                            {{ $t('client.trademark_opposition') }}
                        </span>
                    </b-col>
                    <b-col>
                        <span>
                            {{ $t('client.law_matter') }}
                        </span>
                    </b-col>
                    <b-col>
                        <span>
                            {{ $t('client.patent') }}
                        </span>
                    </b-col>
                    <b-col>
                        <span>
                            {{ $t('client.design') }}
                        </span>
                    </b-col>
                    <b-col>
                        <span>
                            {{ $t('client.design_opposition') }}
                        </span>
                    </b-col>
                    <b-col>
                        {{ $t('client.domain') }}
                    </b-col>
                </b-row>
            </span>
            <span v-else-if="props.column.field === 'process'" class="text-nowrap">
                {{ $t('others.process') }}
            </span>
        </template>
        <!-- Column: Table Column -->
        <template slot="table-row" slot-scope="props">
            <!-- Column: Client Transactions Name -->
            <span v-if="props.column.field === 'name'">
                <b-col>
                    <b-row>
                        <span style="font-size: smaller"><b>{{ props.row.name }}</b></span>
                    </b-row>
                    <b-row v-if="props.row.clientAddress !== null">
                        <span>
                            <tr v-if="clientAddress.address !== null" style="font-size: smaller">{{ props.row.clientAddress.address}}
                            </tr>
                            <tr v-if="clientAddress.country !== null" style="font-size: smaller">{{ props.row.clientAddress.country}}
                            </tr>
                        </span>
                    </b-row>
                </b-col>
            </span>
            <!-- Column: AccountingList -->
            <span v-else-if="props.column.field === 'clientAccountingList'">
                <!-- STOCK-1151 Nevzat 11.09.2024  -->
                <b-row>
                    <b-col>
                        <span :style="[ props.row.clientOwnershipInformation.trademarkActiveCount > 0 ? { 'color': '#7367f0' } : { 'color': 'silver' }]" style="cursor: pointer;font-weight:bold" @click="showDetailList(1, 1, props.row.id)">{{ props.row.clientOwnershipInformation.trademarkActiveCount }}</span> /
                        <span :style="[ props.row.clientOwnershipInformation.trademarkPassiveCount > 0 ? { 'color': '#7367f0' } : { 'color': 'silver' }]" style="cursor: pointer;font-weight:bold" @click="showDetailList(1, 2, props.row.id)">{{ props.row.clientOwnershipInformation.trademarkPassiveCount }}</span>
                    </b-col>
                    <b-col>
                        <span :style="[ props.row.clientOwnershipInformation.nationalTrademarkCount > 0 ? { 'color': '#7367f0' } : { 'color': 'silver' }]" style="cursor: pointer;font-weight:bold" @click="showDetailList(1, 3, props.row.id)">{{ props.row.clientOwnershipInformation.nationalTrademarkCount }}</span>
                    </b-col>
                    <b-col>
                        <span :style="[ props.row.clientOwnershipInformation.trademarkProvisionalCount > 0 ? { 'color': '#7367f0' } : { 'color': 'silver' }]" style="cursor: pointer;font-weight:bold" @click="showDetailList(1, 4, props.row.id)">{{ props.row.clientOwnershipInformation.trademarkProvisionalCount }}</span>
                    </b-col>
                    <b-col>
                        <span :style="[ props.row.clientOwnershipInformation.trademarkObjectionToUsCount > 0 ? { 'color': '#7367f0' } : { 'color': 'silver' }]" style="cursor: pointer;font-weight:bold" @click="showDetailList(1, 5, props.row.id)">{{ props.row.clientOwnershipInformation.trademarkObjectionToUsCount }}</span>
                    </b-col>
                    <b-col>
                        <span :style="[ props.row.clientOwnershipInformation.trademarkOppositionCount > 0 ? { 'color': '#7367f0' } : { 'color': 'silver' }]" style="cursor: pointer;font-weight:bold" @click="showDetailList(1, 6, props.row.id)">{{ props.row.clientOwnershipInformation.trademarkOppositionCount }}</span>
                    </b-col>
                    <b-col>
                        <span :style="[ props.row.clientOwnershipInformation.lawMatterCount > 0 ? { 'color': '#7367f0' } : { 'color': 'silver' }]" style="cursor: pointer;font-weight:bold" @click="showDetailList(1,13,props.row.id)">{{ props.row.clientOwnershipInformation.lawMatterCount }}</span>
                    </b-col>
                    <b-col>
                        <span :style="[ props.row.clientOwnershipInformation.patentCount > 0 ? { 'color': '#7367f0' } : { 'color': 'silver' }]" style="cursor: pointer;font-weight:bold" @click="showDetailList(1, 7, props.row.id)">{{ props.row.clientOwnershipInformation.patentCount }}</span>
                    </b-col>
                    <b-col>
                        <span :style="[ props.row.clientOwnershipInformation.designCount > 0 ? { 'color': '#7367f0' } : { 'color': 'silver' }]" style="cursor: pointer;font-weight:bold" @click="showDetailList(1, 9, props.row.id)">{{ props.row.clientOwnershipInformation.designCount }}</span>
                    </b-col>
                    <b-col>
                        <span :style="[ props.row.clientOwnershipInformation.designOppositionCount > 0 ? { 'color': '#7367f0' } : { 'color': 'silver' }]" style="cursor: pointer;font-weight:bold" @click="showDetailList(1, 10, props.row.id)">{{ props.row.clientOwnershipInformation.designOppositionCount }}</span>
                    </b-col>
                    <b-col>
                        <span :style="[ props.row.clientOwnershipInformation.domainCount > 0 ? { 'color': '#7367f0' } : { 'color': 'silver' }]" style="cursor: pointer;font-weight:bold" @click="showDetailList(1, 11, props.row.id)">{{ props.row.clientOwnershipInformation.domainCount }}</span>
                    </b-col>
                </b-row>

            </span>

            <!-- Column: Process -->
            <span v-else-if="props.column.field === 'process'">
                <span>
                    <b-button v-b-tooltip.html :title="$t('others.edit')" v-b-modal.modal-top variant="primary" class="btn-icon mb-1 ml-1" size="sm" @click="getInfo(props.row.id)">

                        <feather-icon icon="EditIcon" />
                    </b-button>
                    <b-button v-b-tooltip.html :title="$t('others.delete')" variant="warning" class="btn-icon mb-1 ml-1" size="sm" @click="deleted(props.row)">
                        <feather-icon icon="XIcon" />
                    </b-button>
                </span>
            </span>
        </template>

        <!-- pagination -->
        <template slot="pagination-bottom" slot-scope="props">
            <div class="d-flex justify-content-between flex-wrap">
                <div class="d-flex align-items-center mb-0 mt-1">
                    <span class="text-nowrap"> {{ $t('dataTable.total') }} {{ total }} {{ $t('dataTable.record') }}
                    </span>
                </div>
                <div>
                    <b-pagination :value="1" :total-rows="total" v-model="pageNo" :per-page="pageLength" first-number last-number align="right" prev-class="prev-item" next-class="next-item" class="mt-1 mb-0" @input="(value) => getOwnerList()">
                        <template #prev-text>
                            <feather-icon icon="ChevronLeftIcon" size="18" />
                        </template>
                        <template #next-text>
                            <feather-icon icon="ChevronRightIcon" size="18" />
                        </template>
                    </b-pagination>
                </div>
            </div>
        </template>
    </vue-good-table>
</div>
</template>

<script>
export default {
    data() {
        return {
            name: "",
            // email:"",
            countrySelect: 0,
            countryOption: [],
            sectorSelectList: [],
            sectorOption: [],
            total: 0,
            pageLength: 10,
            pageNo: 1,
            dir: false,
            clientAddress: '',
            rows: [],
            searchTerm: '',
        }
    },
    computed: {
        columnsComputed() {
            const base = [{
                label: this.$t('client.name'),
                field: 'name'
            }, ]
            const processCol = {
                label: this.$t('others.process'),
                field: 'process',
                width: '10em'
            }
            return [...base, {
                field: 'clientAccountingList'
            }, processCol]
        },
    },
    mounted() {
        this.getOwnerList()
    },
    methods: {
        getPopoverConfig(clientAccounting) {
            const forInvoice = clientAccounting.forInvoice === true ? this.$t("others.yes") : this.$t("others.no");
            const forAgent = clientAccounting.forAgent === true ? this.$t("others.yes") : this.$t("others.no");
            const combinedTitle = '';
            const combinedContent = `<strong>${this.$t("client.for_agent")}: </strong> ${forAgent}<br/><strong>${this.$t("client.for_invoice")}: </strong> ${forInvoice}`;
            return {
                title: combinedTitle,
                content: combinedContent,
                html: true,
                placement: 'left',
                trigger: 'click',
                customClass: 'small-popover'
            };
        },
        async deleted(data) {
            data = {
                id: data.id
            }
            const controller = {
                name: 'Client'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$DeleteConfirm().then(result => {
                if (result.value) {
                    this.$store.dispatch('moduleAuth/delete', payload).then((response) => {
                        if (response.data.resultStatus == true) {
                            this.$DeleteAlert()
                            this.getOwnerList()
                        } else {
                            this.$WarningAlert(response.data.resultMessage)
                            this.getOwnerList()
                        }
                    })
                }
            })
        },
        async getInfo(id) {
            this.$refs.ownerFormModal.showInfo(id)
        },
        getOwnerList() {
            this.rows = []
            const controller = {
                name: 'Client'
            }
            const data = {
                name: this.name,
                pageLength: this.pageLength,
                pageNo: this.pageNo,
                isOwner: true,
                countryId: this.countrySelect,
                sectorIdList: this.sectorSelectList
            }
            // , email: this.email
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/getList', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.countrySelect = this.countrySelect
                    this.countryOption = response.data.countryList
                    this.countryOption.splice(0, 0, this.$nullSelected())
                    this.sectorOption = response.data.sectorList
                    this.sectorOption.splice(0, 0, this.$nullSelected("nameTR"))
                    this.total = response.data.total

                    this.rows = response.data.clientList
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
        showDetailList(clientType, recordType, id) {
            if (clientType == 1) {
                if (recordType == 1 || recordType == 2) {
                    this.$refs.agentTransactionsReportTrademarkList.getOwnerTransactionsReportList(recordType, id)
                } else if (recordType == 3) {
                    this.$refs.agentTransactionsReportNationalTrademarkList.getOwnerTransactionsReportList(recordType, id)
                } else if (recordType == 4) {
                    this.$refs.agentTransactionsReportTrademarkProvisionalList.getOwnerTransactionsReportList(recordType, id)
                } else if (recordType == 5) {
                    this.$refs.agentTransactionsReportTrademarkObjectionToUsList.getOwnerTransactionsReportList(recordType, id)
                } else if (recordType == 6) {
                    this.$refs.agentTransactionsReportTrademarkOppositionList.getOwnerTransactionsReportList(recordType, id)
                } else if (recordType == 7) {
                    this.$refs.agentTransactionsReportPatentList.getOwnerTransactionsReportList(recordType, id)
                } else if (recordType == 9) {
                    this.$refs.agentTransactionsReportDesignList.getOwnerTransactionsReportList(recordType, id)
                } else if (recordType == 10) {
                    this.$refs.agentTransactionsReportDesignOppositionList.getOwnerTransactionsReportList(recordType, id)
                } else if (recordType == 11) {
                    this.$refs.agentTransactionsReportDomainList.getOwnerTransactionsReportList(recordType, id)
                } else if (recordType == 13) {
                    this.$refs.agentTransactionsReportLawMatterList.getOwnerTransactionsReportList(recordType, id)
                }
            }
        },
        exportExcel() {
            var controller = {
                name: 'Client',
                actionName: 'CanExport'
            }
            var data = {
                name: this.name,
                isOwner: true,
                countryId: this.countrySelect,
                sectorIdList: this.sectorSelectList
            }
            // , email: this.email
            var payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.$downloadFile("Müvekkil", response.data.base64, 'xlsx')
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        }
    },
}
</script>

<style lang="scss">
.excel-css {
    float: right;
    margin-right: 1em;
    width: 9.5em;
    color: #7367f0;
    border: 1px solid #7367f0;
    background-color: transparent;
    margin-left: 1em;
    height: 2em;
    border-radius: 0.358rem;
}

[dir] .dark-layout .card {
    background-color: #252d3f !important;
    box-shadow: 0 4px 24px 0 rgb(34 41 47 / 24%) !important;
}

.tableSize {
    font-size: 13px !important;
    border-collapse: collapse;
    width: 100%;
    max-width: 100%;
    table-layout: auto;
}

.small-popover {
    width: 150px !important;
}

.small-popover .popover-body {
    font-size: 12px
}
</style>
